import styles from './create-new-category-dialog.module.scss';
import { makeCourseRequest } from '../../../../requestUtils';
import { useContext, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CreateNewCategoryDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void
}

export function CreateNewCategoryDialog(props: CreateNewCategoryDialogProps) {
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [category, setCategory] = useState<string>("");

  const handleCategoryChange = (event: any) => setCategory(event.target.value);

  const missingFields = (): boolean => {
    const requiredFieldsFilled =
      category;
    return requiredFieldsFilled ? false : true;
  };

  const handleAddCategory = () => {
    setLoading(true);
    const body = {
      name: category
    }
    makeCourseRequest(`resource/category/upsert`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t('createNewCategory.addCategoryToList'), type: "info", });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('createNewCategory.couldNotAddCategoryToList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('standard.newCategory')}
      </DialogTitle>
      <DialogContent>
        <Row>
          <Col xl={12}>
            <div className='mb-3'>
              <TextField
                label={<span>{t('standard.category')} &#42;</span>}
                fullWidth
                name='category'
                sx={{ minWidth: 300 }}
                value={category}
                onChange={handleCategoryChange}
              />
            </div>
          </Col>
        </Row>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          onClick={handleAddCategory}
          disabled={loading || missingFields()}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('createNewCategory.addCategory')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default CreateNewCategoryDialog;
